import useDisplayNames from '../useDisplayNames'
import pluralize from 'pluralize'

const useStrategicImperativeDisplayName = () => {
    const { getDisplayName } = useDisplayNames()

    const plural = getDisplayName('strategicImperatives', 'Strategic Imperatives')
    const singular = pluralize.singular(plural)

    return { singular, plural }
}

export default useStrategicImperativeDisplayName
